import stateList from "./stateList/stateList.vue";
import i18n from "../../i18n/index";
import stateService from '../../services/location/StateService';
import countryService from '../../services/location/countryService';


export default {
    components: {
        stateList
    },
    data: () => ({
        hideList: false,
        state: {
            id: '',
            name: '',
            idCountry: '',
            code: ''
        },
        update: 0,
        rules: [value => !!value || i18n.t('field-required')],
        validForm: true,
        loadingSaveButton: false,
        country: [],
        showAdd: true,
        showIcon: false,
        showUpdate: false,
        showDelete: false
    }),
    created() {
        this.getCountries();
    },
    methods: {
        handleState(item) {
            this.hideList = true;
            this.state.idState = item.id;
            this.state.idCountry = item.idCountry.id;
            this.state.name = item.name;
            this.state.code = item.code;
            this.update = 1;
            this.showAdd = false;
            this.showIcon = false;
            this.showUpdate = true;
            this.showDelete = true;
            this.loadingSaveButton = false;
            console.log(item)
        },
        closeState() {
            this.hideList = false;
            this.dialog = false;
            this.state = {
                idCountry: '',
                name: '',
                code: ''
            }
            this.$refs.stateForm.reset();
            this.update = 0;
            this.showAdd = true;
            this.showUpdate = false;
            this.showIcon = false;
            this.loadingSaveButton = false;
            this.showDelete = false;
        },
        async getCountries() {
            await countryService.getCountries().then(response => {
                this.countries = response.data;
            });
        },
        saveState() {
            if (!this.$refs.stateForm.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }
            this.loadingSaveButton = true;
            this.showIcon = true;
            // this.state.id = this.state.id == '' ? this.$refs.stateList.getLenght() + 1 : this.state.id;
            // if (this.update == 1) {
            //     this - update(this.state);
            //     return
            // }
            console.log(this.state)
            stateService.createState(this.state)
                .then(result => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created")
                        });
                        this.$refs.stateList.searchState();
                        this.closeState();
                    }
                })
                .catch(error => {
                    this.loadingSaveButton = false;
                    this.showIcon = false;
                    if (error && error.code) {

                        if (error.code == 'Code dian exist') {
                            this.$notify({
                                group: "app",
                                type: "error",
                                text: "El codigo dian ya existe"
                            })
                        }
                    }
                });
        },
        updateState() {
            let stateId = this.state.idState;
            console.log(stateId)
            let data = {
                name: this.state.name,
                code: this.state.code,
                idCountry: this.state.idCountry
            };
            this.loadingSaveButton = true;
            stateService.updateState(stateId, data)
                .then(result => {
                    this.loadingSaveButton = false;
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created")
                        });
                        this.$refs.stateList.searchState();
                        this.closeState();
                    }
                })
                .catch(err => {
                    this.loadingSaveButton = false;
                    this.showIcon = false;
                    throw err;
                });
        },
        deteleState() {
            let data = { id: this.state.idState };
            this.loadingDelete = true;
            stateService.deleteState(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Departamento Eliminado'
                    });
                    this.$refs.stateList.searchState();
                    this.closeState();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The state has associated cities') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "No se puede eliminar el departamento, tiene ciudades asociadas"
                        })
                    }
                }
                // this.$refs.stateList.searchState();
                // this.closeState();
            });
        }
    }
}